// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";

import Header from "./components/Header";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import SubmitStoryPage from "./components/SubmitStoryPage";
import ThankYouPage from "./components/ThankYouPage";
import TikTokPage from "./components/TikTokPage";
import YouTubePage from "./components/YouTubePage";
import DonatePage from "./components/DonatePage";
import MerchPage from "./components/MerchPage";

/* 👇 This tracks route changes */
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AnalyticsTracker />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/submit" element={<SubmitStoryPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/tiktoks" element={<TikTokPage />} />
          <Route path="/youtube" element={<YouTubePage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/merch" element={<MerchPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
